import React from 'react';
import { get } from 'lodash';

import { useStyles } from './useStyles';
import { documentsSort } from '../../../service/sort';
import { DocumentItem } from '../../DocumentsPage/DocumentItem/DocumentItem';
import { useDocuments } from '../../../selectors/documents';

export const AirportDocuments = React.memo(() => {
    const documents = useDocuments();
    const classes = useStyles();

    return (
        <>
            {documents.sort(documentsSort).map((doc, index) => (
                <DocumentItem
                    key={index}
                    id={doc.id}
                    primaryText={`${doc.airport} ${doc.type}`}
                    secondaryText={doc.description}
                    download={get(doc, 'syncTime')}
                    downloadFormat="DD.MM.YYYY HH:mm"
                    downloadPreifix=""
                    className={classes.nested}
                />
            ))}
        </>
    );
});

AirportDocuments.displayName = 'AirportDocuments';
